import $ from 'jquery';
import Swiper from 'swiper';

/**
 * Initialize Testimonial Swiper carousels
 */
export function initTestimonialSwiper() {
	$('.testimonial-scroll.swiper').each(function () {
		const $testimonial = $(this);
		const testimonialId = $testimonial.attr('id');

		if (testimonialId) {
			new Swiper(`#${testimonialId}`, {
				a11y: {
					enabled: true,
					slideRole: 'link',
				},
				navigation: {
					nextEl: `#${testimonialId} .swiper-button-next`,
					prevEl: `#${testimonialId} .swiper-button-prev`,
				},
				slidesPerView: 'auto',
				breakpoints: {
					320: {
						spaceBetween: 20,
					},
					1024: {
						spaceBetween: 30,
					},
				},
			});
		}
	});

	// Set equal height for testimonial slides
	function setTestimonialHeight() {
		let maxHeight = 0;
		$('.testimonial-scroll .swiper-slide').each(function () {
			const height = $(this).outerHeight();
			if (height > maxHeight) {
				maxHeight = height;
			}
		});
		$('.testimonial-scroll .swiper-slide').css('min-height', maxHeight + 'px');
	}

	$(window).on('load', setTestimonialHeight);
	$(window).on('resize', setTestimonialHeight);
}
